angular.module('services')
    .service('currencySrv', [
        '$rootScope', '$translate', '$interpolate', '$log',
        function ($rootScope, $translate, $interpolate, $log) {
            let cursByLang;

            $translate('currencies').then(msg => {
                cursByLang = msg.$$unwrapTrustedValue();

                $rootScope.$emit('currency', {
                    currencies: service.currencies,
                    filtered: service.getFiltered()
                });
            }).catch(e => $log.log(e));

            const service = {
                currencies: [
                    { id: 1, symbol: 'A$',    code: 'AUD',  format: '{{ symbol }}{{ value }}' },
                    { id: 2, symbol: '$',     code: 'USD',  format: '{{ symbol }}{{ value }}' },
                    { id: 3, symbol: '€',     code: 'EUR',  format: '{{ symbol }}{{ value }}' },
                    { id: 4, symbol: 'د.إ',   code: 'AED',  format: '{{ symbol }}{{ value }}' },
                    { id: 5, symbol: '₽',     code: 'RUB',  format: '{{ symbol }}{{ value }}' },
                    { id: 6, symbol: 'NZ$',   code: 'NZD',  format: '{{ symbol }}{{ value }}' }
                ],
                getFiltered() {
                    return cursByLang && this.currencies.filter(cur => cursByLang.indexOf(cur.code) > -1);
                },
                getCurrency(code) {
                    return _.find(this.currencies, { code });
                },
                getSymbol(code) {
                    return _.find(this.currencies, { code }).symbol;
                },
                getFormattedValue(value, code) {
                    if (!value) {
                        $log.error(`currency value is ${value}!`, value);
                        return null;
                    }
                    if (!code) {
                        $log.error('currency code is incorrect!', code);
                        return '#ERROR#';
                    }
                    let currency = this.getCurrency(code);
                    if (currency) {
                        let format = this.getCurrency(code).format;
                        return $interpolate(format)({
                                value: parseFloat(value),
                                symbol: this.getSymbol(code)
                            });
                    } else {
                        $log.error('currency is missing or incorrect code!', code);
                        return '#ERROR#';
                    }
                }
            };

            return service;
        }
    ]);